<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import BaseModal from "@/components/global-themed/BaseModal.vue";
import VideoIframe from "@/components/video/VideoIframe.vue";

const emit = defineEmits(['close']);

const showCalendly = () => {
  if (!window.Calendly) {
    window.open('https://calendly.com/hike-seo/meet-your-account-managers', '_blank');
    return;
  }

  window.Calendly.initPopupWidget({url: 'https://calendly.com/hike-seo/meet-your-account-managers'})
}
</script>

<template>
  <Teleport to=".tailwind">
    <BaseModal @close="emit('close')">
      <div class="tw-flex tw-flex-col tw-gap-4">
        <div class="tw-text-2xl tw-font-medium tw-text-neutral-900">
          Meet my managers
        </div>

        <VideoIframe
          class="tw-h-[500px]"
          video-url="https://player.vimeo.com/video/1074595854?h=8e6ccc2ba9&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        />

        <DefaultButton
          class="tw-self-center"
          @click="showCalendly"
        >
          Book a call with one of the team
        </DefaultButton>
      </div>
    </BaseModal>
  </Teleport>
</template>
